export default "__VITE_ASSET__49af1271__"